// Temporary utility to safely use withLatestFrom with StateObservable
// This works around a compatibility issue between RxJS 7 and redux-observable 2.0
import type { StateObservable } from 'redux-observable';
import { combineLatest, type Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

/**
 * A safe version of withLatestFrom that works with StateObservable
 * This is a temporary workaround for RxJS compatibility issues
 */
export function safeWithLatestFromState<S>(state$: StateObservable<S>) {
  return function withLatestFromHandler<U>(source: Observable<U>): Observable<[U, S]> {
    // Simply access the current state value synchronously like withLatestFrom should do
    return source.pipe(map((value) => [value, state$.value] as [U, S]));
  };
}

/**
 * Alternative implementation using combineLatest for more reliability
 */
export function safeWithLatestFromStateCombined<S>(state$: StateObservable<S>) {
  return function combinedLatestHandler<U>(source: Observable<U>): Observable<[U, S]> {
    // @ts-expect-error - Complex RxJS type compatibility issue
    return combineLatest([
      source,
      // @ts-expect-error - StateObservable type compatibility
      state$.pipe(take(1)), // Take current state value
    ]);
  };
}
